import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'react-bootstrap';

import { formatDate, _formatDate, _diff2Date } from '../../../utils';

import { makeGetToken } from '../../../lib/selector';

import RenderDatePicker from '../../input/renderDatePicker';
import { summaryOrdCondRequest } from '../../../containers/summary/actions';
import { v4 as uuidv4 } from 'uuid';
import { setToast } from '../../../containers/client/actions';
import { translate } from 'react-i18next';

class FormSearchSKLDK extends Component {
  submit = (values) => {
    const { txtSearch, typeOrder, txtStatus, startDate, endDate } = values;
    const { token, account } = this.props;

    console.log(account);

    const maxDay = token && token['config'] ? token['config']['maxDay'] : 90;

    const _typeOrder = typeOrder;
    const _txtStatus = txtStatus;
    const _diff = _diff2Date(endDate, startDate);
    if (_diff < 0) {
      this._handleToast('Thời gian tìm kiếm không hợp lệ');
      return;
    }
    if (_diff > maxDay) {
      this._handleToast('Chỉ được xuất báo cáo trong vòng ' + maxDay + ' ngày');
      return;
    }

    const _txtSearch = txtSearch ? txtSearch.toUpperCase() : '';
    const uuid = uuidv4();

    const params = {
      group: 'ORS',
      user: token.user,
      session: token.session,
      cmd: 'getOrsOrderList',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: account.acntNo,
        subAcntNo: account.subAcntNo,
        ordertype: _typeOrder,
        createddt: startDate.split('/').reverse().join('-'),
        expireddt: endDate.split('/').reverse().join('-'),
        symbol: _txtSearch,
        status: _txtStatus,
      },
    };

    this.props.dispatch(summaryOrdCondRequest(params));
    this.props.saveParams(params);
  };

  componentDidUpdate(preProps) {
    const { account, reset } = this.props;

    if (account && account !== preProps.account) {
      reset();
      setTimeout(() => {
        if (this.refSubmit) this.refSubmit.click();
      }, 100);
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
    };
    this.props.dispatch(setToast(toastMsg));
  };

  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      reset,
      startDate,
      endDate,
      t,
    } = this.props;

    const _loailenh = [
      { value: 'CNL', label: t('txt-all') },
      { value: 'GTC', label: t('txt-out-time') },
      { value: 'TSO', label: t('txt-trend-order') },
      { value: 'TPO', label: t('txt-take-profit') },
      { value: 'STO', label: t('txt-stop-loss') },
      { value: 'PCO', label: t('txt-purchase-order') },
    ];

    const _status = [
      { value: '', label: t('txt-all') },
      { value: 'P', label: t('txt-cond-pending') },
      { value: 'C', label: t('txt-cond-cancelling') },
      { value: 'I', label: t('txt-cond-active') },
      { value: 'A', label: t('txt-cond-activated') },
      { value: 'F', label: t('txt-cond-final') },
      { value: 'E', label: t('txt-cond-expired') },
      { value: 'R', label: t('txt-cond-wait-react') },
    ];

    return (
      <form
        className="p-2 mt-2 form-search-head"
        onSubmit={handleSubmit(this.submit)}
      >
        <Form.Group className="d-flex mb-0 p-2" controlId="formPlaintextSymbol">
          <label className="text-white-50 fz-14" style={{ width: '20mm' }}>
            {t('txt-search')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              name="txtSearch"
              component="input"
              maxLength="8"
              type="text"
              className="form-control form-input text-uppercase fz-14"
              placeholder={t('txt-symbol')}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {t('txt-label-from')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              classname="form-control form-input fz-14"
              name="startDate"
              type="start"
              startDate={startDate}
              endDate={endDate}
              component={RenderDatePicker}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {t('txt-label-to')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              classname="form-control form-input fz-14"
              name="endDate"
              type="end"
              startDate={startDate}
              endDate={endDate}
              component={RenderDatePicker}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {`Loại lệnh`}
          </label>
          <div>
            <Field
              name="typeOrder"
              component="select"
              className="form-control form-input fz-14"
            >
              {_loailenh.map((statusOption) => (
                <option value={statusOption.value} key={statusOption.value}>
                  {statusOption.label}
                </option>
              ))}
            </Field>
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {`Trạng thái`}
          </label>
          <div>
            <Field
              name="txtStatus"
              component="select"
              className="form-control form-input fz-14"
            >
              {_status.map((statusOption) => (
                <option value={statusOption.value} key={statusOption.value}>
                  {statusOption.label}
                </option>
              ))}
            </Field>
          </div>
          <button
            ref={(el) => (this.refSubmit = el)}
            type="submit"
            disabled={submitting}
            className="btn-reload fz-14 font-weight-bold text-white ml-2 w-auto"
          >
            {t('txt-search')}
          </button>
        </Form.Group>
      </form>
    );
  }
}

FormSearchSKLDK = reduxForm({
  form: 'saokelenhdieukien',
  enableReinitialize: true,
})(FormSearchSKLDK);

const selector = formValueSelector('saokelenhdieukien');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();

  const mapStateToProps = (state, props) => {
    const token = getToken(state);
    const { txtSearch, txtStatus, typeOrder, startDate, endDate } = selector(
      state,
      'txtSearch',
      'txtStatus',
      'typeOrder',
      'startDate',
      'endDate'
    );

    const numDay = token && token['config'] ? token['config']['numDay'] : 30;

    const d = new Date();
    d.setDate(d.getDate() - numDay);

    return {
      token,
      txtSearch,
      txtStatus,
      typeOrder,
      startDate,
      endDate,
      initialValues: {
        txtSearch: '',
        txtStatus: '',
        typeOrder: 'CNL',
        endDate: formatDate(new Date(), '/', 'dmy'),
        startDate: formatDate(d, '/', 'dmy'),
      },
    };
  };
  return mapStateToProps;
};

FormSearchSKLDK = connect(makeMapStateToProps)(FormSearchSKLDK);

export default translate('translations')(FormSearchSKLDK);
